// extracted by mini-css-extract-plugin
export default {"button":"AuthButton_button__g68RR","active":"AuthButton_active__nNbKG"};